import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "br_cookie_consent_v1";

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const v = window.localStorage.getItem(STORAGE_KEY);
            if (!v) setVisible(true);
        } catch (e) {
            // Ignore storage errors (privacy mode, etc.)
        }
    }, []);

    function accept() {
        try { window.localStorage.setItem(STORAGE_KEY, "accepted"); } catch (e) { /* noop */ }
        setVisible(false);
        // Allow analytics
        if (window.gtag) window.gtag("consent", "update", { analytics_storage: "granted" });
    }

    function decline() {
        try { window.localStorage.setItem(STORAGE_KEY, "declined"); } catch (e) { /* noop */ }
        setVisible(false);
        if (window.gtag) window.gtag("consent", "update", { analytics_storage: "denied" });
        // Disable Clarity if loaded
        if (window.clarity) {
            try { window.clarity("stop"); } catch (e) { /* noop */ }
        }
    }

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-consent-banner"
            className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 rounded-2xl border border-[#D4AF37]/30 bg-[#0B1220]/95 backdrop-blur-lg shadow-2xl p-5"
        >
            <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-2">Cookies</p>
            <p className="text-sm text-slate-200 leading-relaxed">
                We use a few essential cookies to keep you signed in, plus Google Analytics and
                Microsoft Clarity to understand how the site is used. See our{" "}
                <Link to="/privacy" className="text-[#D4AF37] underline">Privacy Policy</Link>.
            </p>
            <div className="mt-4 flex gap-2">
                <button
                    type="button"
                    onClick={decline}
                    data-testid="cookie-decline-btn"
                    className="flex-1 rounded-full border border-white/15 px-4 py-2 text-sm text-slate-200 hover:bg-white/5 transition"
                >
                    Decline analytics
                </button>
                <button
                    type="button"
                    onClick={accept}
                    data-testid="cookie-accept-btn"
                    className="flex-1 rounded-full bg-[#D4AF37] px-4 py-2 text-sm font-medium text-[#0B1220] hover:bg-[#c19f2f] transition"
                >
                    Accept all
                </button>
            </div>
        </div>
    );
}
